import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StoreMetadata, normalizeUrl, useAnalytics } from "@commons-monorepo/index";
import { useAppParams } from "@commons-monorepo/index";
import { SHARE_STORE_EVENTS } from "./share-store.events";
import { useOutletContext, useSearchParams } from "@remix-run/react";

export const useShareStore = () => {
  const { storeMetadata } = useOutletContext<{
    storeMetadata: StoreMetadata;
  }>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { t } = useTranslation();
  const { partnerId, productId, comboId } = useAppParams();
  const [queryParams, setQueryParams] = useSearchParams();
  const data: any = useOutletContext();

  const [copySuccess, setCopySuccess] = useState("");

  const showModal = queryParams.get("share") !== null;
  const showProductModal = !!productId || !!comboId;

  const handleSocialButton = (source: string, shareProduct?: boolean) => {
    logEvent(
      !shareProduct
        ? SHARE_STORE_EVENTS.SELECT_SHARE_STORE
        : SHARE_STORE_EVENTS.SELECT_SHARE_PRODUCT,
      {
        source,
      },
    );
  };

  const sharedUrl = () => {
    const urlDetail = location.href.includes("producto")
      ? `/producto/${productId}`
      : location.href.includes("combo")
      ? `/combo/${normalizeUrl(comboId || "")}`
      : "";
    if (data?.storeUseSubdomain) return `${location.origin}${urlDetail}`;
    const url = location.href.includes("catalogo")
      ? `${location.origin}/catalogo/${partnerId}`
      : location.origin;
    return `${url}${showProductModal ? urlDetail : ""}`;
  };

  const closeModal = () => {
    queryParams.delete("share");
    setQueryParams(queryParams);
    setCopySuccess("");
  };

  const copyLink = () => {
    navigator?.clipboard?.writeText(sharedUrl());
    handleSocialButton("Copiar", showProductModal);
    setCopySuccess("Enlace copiado");
  };

  return {
    t,
    showModal,
    showProductModal,
    copySuccess,
    sharedUrl,
    closeModal,
    copyLink,
    handleSocialButton,
  };
};
